<template>
  <my-modal>

    <div class="modal-container">
      <div class="modal-header">
        <h3>Seleccionar comprobante</h3>
      </div>
      <div class="modal-body">
        <DataList
          :url="requestUrl"
          :fields="fields"
          :rowClick="selectComprobante"
          :toPesos="toPesos"
          :toDate="toDate"
          :modal="true"
          ref="datatable"
        />
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger" @click="cerrarModal">Cerrar</button>
      </div>
    </div>
  </my-modal>
</template>

<script>
import MyModal from "@/components/layouts/MyModal.vue";
import DataList from "@/components/layouts/DataList.vue";

export default {
  name: "ModalListarComprobantes",
  components: {DataList, MyModal},
  props: ['usedIds'],
  data() {
    return {
      movimientos: [],

      fields: [
        {
          name: "denominacion",
          label: "",
          type: "title",
          class: "text-alternate",
          append: " - "
        },
        {
          name: "total",
          label: "",
          type: "title",
          class: "text-success",
          prepend: "$"
        },
        {
          name: "comprobante.cliente",
          label: "Cliente",
          type: "field",
          class: "text-info"
        },
        {
          name: "forma_pago",
          label: "Forma de pago",
          type: "field",
          class: ""
        },
        {
          name: "created_at",
          label: "Fecha",
          type: "field",
          class: ""
        },
        {
          name: "user.nombre",
          label: "Vendedor",
          type: "field",
          class: ""
        }
      ],
      toPesos: ["total"],
      toDate: ["created_at"],
      loading: false
    }
  },
  created() {
    const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
      this.cerrarModal();
      next(false);
    });

    this.$once("hook:destroyed", () => {
      unregisterRouterGuard();
    });
  },
  computed: {
    requestUrl(){
      return '/movimiento/sin-entregar?used='+JSON.stringify(this.usedIds)
    }
  },
  methods: {
    selectComprobante(movimiento) {
      this.$emit("selectComprobante", movimiento);
      setTimeout(() => {this.clear()}, 10)
    },
    cerrarModal() {
      this.$emit("cerrarListarComprobantes");
    },
    clear(){
      this.$refs.datatable.clear();
    }
  },
}
</script>

<style scoped>

</style>
